import HeadData from 'components/Common/HeadData'
import { useIntl } from 'react-intl'

function CruiseDeparturesPageHeadData(props: { place: App.Place }) {
  const intl = useIntl()
  const { place } = props
  const location = place.name
  const countryName = place.canonicalName?.split(',')?.pop()?.replace(' ', '') ?? ''
  const currentYear = new Date().getFullYear()
  const title = intl.formatMessage(
    {
      id: 'akOiI-epNODmQy5a1Cor',
      defaultMessage: 'Cruises from {placeName} | Best Deals {currentYear} - {nextYear}',
      description: 'SEO page title for cruise departure port landing page',
    },
    { placeName: place.name, currentYear, nextYear: currentYear + 1 },
  )
  let description = ''
  if (countryName) {
    description = intl.formatMessage(
      {
        id: 'dAF0To0qLYkkgx6-ZqRE',
        defaultMessage: 'Discover cruises departing from {location}, {countryName}. Book now and save more with our exclusive offers to top destinations',
        description: 'SEO meta description for cruise departure port page with country name',
      },
      { location, countryName },
    )
  } else {
    description = intl.formatMessage(
      {
        id: 'QKQlMOxH2Wq27jRehTg1',
        defaultMessage: 'Discover cruises departing from {location}. Book now and save more with our exclusive offers to top destinations',
        description: 'SEO meta description for cruise departure port page without country name',
      },
      { location },
    )
  }

  return <HeadData title={title} description={description} />
}

export default CruiseDeparturesPageHeadData
